import React, { useCallback, useEffect } from 'react';
import { useFetcher } from '@remix-run/react';
import { type AuthData, PAYMENT_PROVIDER_CLEENG } from '~/utils/storefront';
import type { UIComponent } from '~/services/layout/index.ts';
import { getPluginConfig } from '~/utils/get-plugin-configuration.ts';
import { isValidUrl } from '~/utils/validations.ts';
import CleengProvider from './Providers/Cleeng';
import manifest from '../config/manifest.ts';

type Props = {
  uiComponent: UIComponent;
};

export default function SubscriptionManagement({
  uiComponent,
}: Props): JSX.Element {
  const fetcher = useFetcher();
  const config = getPluginConfig<typeof manifest>(manifest, uiComponent);

  useEffect(() => {
    const authURL = config?.data?.authentication_feed_url;

    if (!isValidUrl(authURL?.source)) {
      return;
    }

    fetcher.submit(authURL, {
      action: '/api/payment-auth',
      method: 'post',
    });
  }, []);

  const { select_payment_provider } = config?.general;

  const renderSubscriptionProvider = useCallback(() => {
    if (select_payment_provider === PAYMENT_PROVIDER_CLEENG) {
      return (
        <CleengProvider config={config} authData={fetcher.data as AuthData} />
      );
    }
  }, [config, select_payment_provider, fetcher.data]);

  if (!fetcher.data) {
    return <></>;
  }

  return <>{renderSubscriptionProvider()}</>;
}
